import type { LoginDeviceApi } from 'api-typings/users/users';
import type { LoginDevice } from './login-devices.model';

export function transformLoginDevice(device: LoginDeviceApi): LoginDevice {
  return {
    id: device.last_login, // use last login timestamp as the pseudo-id
    userAgent: device.user_agent,
    platform: device.platform,
    city: device.city,
    country: device.country,
    lastLogin: device.last_login * 1000,
    token: device.token,
    isActive: device.is_active ?? false,
    isCurrent: device.is_current ?? false,
    isMobile:
      device.user_agent.includes('Android') ||
      device.user_agent.includes('iOS'),
  };
}
